export class EventEmitter {
    constructor() {
        this.eventRegister = {};
    }
    on(name, fn) {
        if (!this.eventRegister[name]) {
            this.eventRegister[name] = [];
        }
        this.eventRegister[name].push(fn);
    }
    trigger(name, evt) {
        if (!this.eventRegister[name])
            return false;
        this.eventRegister[name].forEach((fn) => fn.call(null, evt));
    }
    off(name, fn) {
        if (this.eventRegister[name]) {
            const index = this.eventRegister[name].indexOf(fn);
            if (index >= 0)
                this.eventRegister[name].splice(index, 1);
        }
    }
}
